import { render, staticRenderFns } from "./SocialRewardsModal.vue?vue&type=template&id=464696a1&scoped=true&"
import script from "./SocialRewardsModal.vue?vue&type=script&lang=ts&"
export * from "./SocialRewardsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewardsModal.vue?vue&type=style&index=0&id=464696a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464696a1",
  null
  
)

export default component.exports